import { APP_INITIALIZER, Inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { load } from '../config/config.actions';
import { AppConfigState } from '../config/config.reducer';
import { start, finish } from './initializer.actions';

export function initApplication(store: Store<AppConfigState>): Function {
    return () => new Promise(resolve => {
      store.dispatch(load());
      store.dispatch(start());
      store.select((state: any) => state.config)
        .pipe(filter(e => e.translations), take(1))
        .subscribe(() => {
          store.dispatch(finish());
          resolve(true);
        });
    });
  }

export const initAppConfig = {
    provide: APP_INITIALIZER,
    useFactory: initApplication,
    multi: true,
    deps: [[new Inject(Store)]]
};
